module.exports = __webpack_public_path__ + "img/home-pencil-yellow.1437b456.svg";